import Text from 'components/Text/Text';
import React, { useContext } from 'react';
import { IFirmwareContext, FirmwareContext } from '../../../firmwareState/firmwareContext';
import classNames from 'classnames';
import Button from 'components/Button/Button';
import breadcrumbs from 'images/breadcrumbs.svg';
import style from './ResetBtn.module.scss';

const ResetBtn: React.FC = () => {
	const { resetSelectedControls, searchString, IDSelectedTypeFirmware, isUnassignedFirmware } =
		useContext<IFirmwareContext>(FirmwareContext);

	const resetBtnClasses = classNames(style.resetBtn, {
		[style.active]: searchString || IDSelectedTypeFirmware || isUnassignedFirmware,
	});

	return (
		<Button
			className={resetBtnClasses}
			theme="secondary"
			onClick={resetSelectedControls}
			icon={
				<svg className={style.icon}>
					<use xlinkHref={`${breadcrumbs}#resetIcon`} />
				</svg>
			}
			data-test="ResetBtn">
			<Text translationNameSpace="listing" translationKey="resetButton" asFragment={true} />
		</Button>
	);
};

export default ResetBtn;
